// src/PlatformApp.js
//
// The Super Admin panel's own top-level app tree — mounted by App.js only
// when this build is being served from the platform host (see App.js's own
// isPlatformHost check and this feature's own plan doc's Phase 6: "gated to
// render only when served from the admin. host"). Deliberately a SEPARATE
// component from the tenant app's own return tree (rather than one Routes
// list branching internally) so a platform-staff session's provider stack
// (PlatformAuthProvider) never even mounts on a tenant subdomain, and vice
// versa — the same "these two sessions must never collide" reasoning
// PlatformAuthContext.js/services/api.js's platformRequest already apply to
// storage keys and API base URLs.
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PlatformAuthProvider } from "./context/PlatformAuthContext";
import PlatformProtectedRoute from "./components/PlatformProtectedRoute";
import PlatformLogin from "./pages/Platform/PlatformLogin";
import PlatformAccessDenied from "./pages/Platform/PlatformAccessDenied";
import PlatformDashboardLayout from "./layouts/PlatformDashboardLayout";
import Companies from "./pages/Platform/Companies";
import CompanyDetail from "./pages/Platform/CompanyDetail";
import PlatformUsers from "./pages/Platform/PlatformUsers";
import PlatformGroups from "./pages/Platform/PlatformGroups";
import PlatformSettings from "./pages/Platform/PlatformSettings";
import PlatformNotifications from "./pages/Platform/PlatformNotifications";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function PlatformApp() {
  return (
    <PlatformAuthProvider>
      <BrowserRouter>
        <ToastContainer position="top-right" autoClose={3000} theme="colored" />
        <Routes>
          <Route path="/platform-login" element={<PlatformLogin />} />

          <Route element={<PlatformDashboardLayout />}>
            <Route
              path="/platform/companies"
              element={
                <PlatformProtectedRoute requiredPermission="company_view">
                  <Companies />
                </PlatformProtectedRoute>
              }
            />
            <Route
              path="/platform/companies/:id"
              element={
                <PlatformProtectedRoute requiredPermission="company_view">
                  <CompanyDetail />
                </PlatformProtectedRoute>
              }
            />

            <Route
              path="/platform/users"
              element={
                <PlatformProtectedRoute requiredPermission="platformuser_manage">
                  <PlatformUsers />
                </PlatformProtectedRoute>
              }
            />
            <Route
              path="/platform/groups"
              element={
                <PlatformProtectedRoute requiredPermission="platformuser_manage">
                  <PlatformGroups />
                </PlatformProtectedRoute>
              }
            />
            <Route
              path="/platform/settings"
              element={
                <PlatformProtectedRoute requiredPermission="platformsetting_manage">
                  <PlatformSettings />
                </PlatformProtectedRoute>
              }
            />
            <Route
              path="/platform/notifications"
              element={
                <PlatformProtectedRoute>
                  <PlatformNotifications />
                </PlatformProtectedRoute>
              }
            />

            <Route path="/platform/denied" element={<PlatformAccessDenied />} />

            <Route
              path="*"
              element={
                <PlatformProtectedRoute requiredPermission="company_view">
                  <Companies />
                </PlatformProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </PlatformAuthProvider>
  );
}
